import {getActiveDesignSystem} from './designSystem';

declare module '@mui/material' {
  interface PaletteBackground {
    menu: string;
    dark: string;
  }
}

const {lightModePalette, text: textColors} = getActiveDesignSystem();

export const LightModePalette = lightModePalette;

export const LightModeTypography = {
  fontFamily: '-apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif',
  h1: {
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: 1.35,
    color: textColors.primary,
  },
  h2: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: 1.4,
    color: textColors.primary,
  },
  h3: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.4,
    color: textColors.primary,
  },
  h4: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.45,
    color: textColors.primary,
  },
  h5: {
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: 1.45,
    color: textColors.primary,
  },
  h6: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.45,
    color: textColors.primary,
  },
  body1: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
    color: textColors.primary,
  },
  body2: {
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 1.5,
    color: textColors.secondary,
  },
  subtitle1: {
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 1.4,
    color: textColors.secondary,
  },
  subtitle2: {
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: 1.4,
    color: textColors.primary,
  },
  caption: {
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: 1.35,
    color: textColors.secondary,
  },
  button: {
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: 1.2,
    textTransform: 'none' as const,
  },
  overline: {
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '0.08em',
    textTransform: 'uppercase' as const,
    color: textColors.secondary,
  },
};
